import gapmoment from "@/common/gap/util/gapmoment"

export const MISSION_ONGOING = "ONGOING";
export const MISSION_SCHEDULED = "SCHEDULED";
export const MISSION_ENDED = "ENDED";

export default class Mission {
  advertiserName = "";
  gameName = null;
  name = "";
  codeName = "";
  startAt = "";
  endAt = "";
  customerSupportName = "";
  customerSupportUrl = "";
  agitUrl = "";
  missionDescription = "";
  extraInfo = {
    kakaoRewardApiKey: ""
  };
  totalPurchaseAmount = 0;
  rewardUnitPrice = 0;

  rewardType = "KAKAO_EMOTICON";
  adAccount = 1;
  appId = 1;

  /***
   * 사용자 표시용 상태 정보 (진행중 종료 예정)
   * @type {string}
   */
  detailStatus = "";

  constructor(missionDto) {
    if (missionDto) {
      for (const key of Object.keys(missionDto)) {
        this[key] = missionDto[key];
      }

      this.startAt = gapmoment.kstToLtz(this.startAt);
      this.endAt = gapmoment.kstToLtz(this.endAt);

      const now = Date.now();
      const startAtDate = gapmoment.unixTime(this.startAt);
      const endAtDate = gapmoment.unixTime(this.endAt);
      if (startAtDate <= now && now <= endAtDate) {
        this.detailStatus = MISSION_ONGOING;
      } else if (now < startAtDate) {
        this.detailStatus = MISSION_SCHEDULED;
      } else {
        this.detailStatus = MISSION_ENDED;
      }
    }
  }

  convertToDto() {
    const dto = JSON.parse(JSON.stringify(this));

    dto.startAt = dto.startAt + " 00:00:00";
    dto.endAt = dto.endAt + " 23:59:59";
    dto.startAt = gapmoment.ltzToKst(dto.startAt);
    dto.endAt = gapmoment.ltzToKst(dto.endAt);

    return dto;
  }

  isOnGoing() {
    return this.detailStatus === MISSION_ONGOING;
  }

  isScheduled() {
    return this.detailStatus === MISSION_SCHEDULED;
  }

  isEnded() {
    return this.detailStatus === MISSION_ENDED;
  }
}
